module.exports = __webpack_public_path__ + "static/media/micro-placa.a98865ef.svg";